<template>
     <div class="publicViewClass" style="padding-top:0">
          <div class="edit-step">
            <topicSteps :active = "1" :propList="propList"></topicSteps>
        </div> 
         <div id="editPaper" class="app-inner">
            <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/teacheManage/enCourse')">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openSteps('ruleForm')"
            >
             下一步
           </el-button>
            </div>
            <div class="edit-from">
             <div class="public-tit flex align-cen">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  基本信息
                    </div>
              </div>
               <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
                  <el-form-item label="课程标题：" prop="title">
                    <el-input v-model="form.title" placeholder="请输入您的课程标题【1-50】" clearable></el-input>
             </el-form-item>
              <el-form-item label="课程分类：" prop="classifyId">
                    <el-select v-model="form.classifyId" placeholder="选择课程分类">
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                    <el-form-item label="课程封面：" prop="logo">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">373*280</span></div>
                    <img :src="form.logo" class="avatar" v-if="form.logo">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.logo" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span>
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.logo" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
                 <el-form-item label="推荐状态：">
                    <el-radio v-model="form.recommend" label="0">未推荐</el-radio>
                    <el-radio v-model="form.recommend" label="1">推荐</el-radio>
                </el-form-item>
                <el-form-item label="排序：" >
                    <el-input v-model="form.sort" placeholder="请输入排序" clearable></el-input>
                 </el-form-item>
                   <el-form-item label="课程简介：">
                        <el-input
                        type="textarea"
                        placeholder="请输入课程简介 限制500字"
                        v-model="form.introduction"
                        maxlength="500"
                        show-word-limit
                        rows="5"
                        >
                        </el-input>
                </el-form-item>
               </el-form>
                  <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">指派学员</p>
                        </div>
                                <div class="settings-box-check form-check">
                                <el-checkbox v-model="checked">
                                    选择分组 <span>(已选{{dynamicTags1.length || '0'}}个学员组)</span>
                                </el-checkbox>
                                <div v-if="checked">
                                  <div class="tagsinput">
                                    <div class="classItem">
                                        <el-tag
                                            :key="tag.id"
                                            v-for="tag in dynamicTags1"
                                            closable
                                            :disable-transitions="false"
                                            @close="handleClose(tag,1)">
                                            {{tag.name || tag.allocateName}}
                                            </el-tag>
                                        </div>
                                </div>
                                <div class="select-stu" @click="openStu(1)">选择分组</div>
                                </div>
                             </div>
                                    <div class="settings-box-check form-check">
                                <el-checkbox v-model="checked1">
                                    选择学员 <span>(已选{{dynamicTags2.length || '0'}}个学员)</span>
                                </el-checkbox>
                                <div v-if="checked1">
                                  <div class="tagsinput">
                                    <div class="classItem">
                                        <el-tag
                                            :key="tag.id"
                                            v-for="tag in dynamicTags2"
                                            closable
                                            :disable-transitions="false"
                                            @close="handleClose(tag,2,tag)">
                                            {{tag.userName || tag.allocateName}}
                                            </el-tag>
                                        </div>
                                </div>
                                <div class="select-stu" @click="openStu(2)">选择学员</div>
                                </div>
                             </div>
                  </div>
                               <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  关联试卷
            </div>
                <div class="mft public-btn-small">
                     <div class="public-btn-small-primary" @click="openBl">
                          关联相关试卷       
                    </div>
                </div>
        </div>
                <!-- 关联试卷 -->
         <div class="App-tab">
         <el-table
            :data="relationList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column label="试卷封面" align="center">
              <template slot-scope="scope" >
                <img :src="scope.row.logo ? scope.row.logo : require('../../../assets/images/nullimg.png')" alt="" style="display: block;width:50%;margin:0 auto" v-if="scope.row.id !=0"> 
            </template>
            </el-table-column>
             <el-table-column :prop=" isShowId ? 'paperId' : 'id'" label="试卷ID" align="center" width="200">
          </el-table-column>
             <el-table-column prop="paperName" label="试卷名称" align="center" width="300">
          </el-table-column>
               <el-table-column prop="classifyName" label="试卷分类" align="center" >
          </el-table-column>
           <el-table-column prop="examNum" label="考试人次" align="center" >
          </el-table-column>
            <el-table-column prop="" label="考试时间" align="center" >
             <template slot-scope="scope">
              <div>
                {{scope.row.answerTimeLimit ? `${scope.row.answerTimeLimit}分钟` : '-'}}
              </div>
             </template>
          </el-table-column>
            <el-table-column prop="questionNum" label="题目数" align="center" >
          </el-table-column>
            <el-table-column prop="practiceMode" label="练习试卷" align="center" >
                    <template slot-scope="scope">
              <div>
                {{scope.row.practiceMode == 1 || scope.row.practiceMode == 2 ? '是' : '否'}} 
              </div>
             </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
             <template slot-scope="scope">
            <el-button type="text" size="small" style="color:red" @click.stop="deletPro(scope.row)">取消关联</el-button>
             </template>
             </el-table-column>
         </el-table>
         </div>
         <!-- 通知设置 -->
         <div class="notify-settings-wrap">
            <div class="public-tit flex align-cen">
               <div class="public-tit-list">
                  <i class="icon-al-database-fill"></i>  通知设置
               </div>
            </div>
            <div class="notify-item flex align-cen">
               <span class="notify-label">课程更新通知：</span>
               <el-switch v-model="form.updateAlert" active-value="1" inactive-value="0"></el-switch>
            </div>
            <div class="notify-item">
               <div class="flex align-cen">
                  <span class="notify-label">课程未学通知：</span>
                  <el-switch v-model="form.unlearnAlert" active-value="1" inactive-value="0"></el-switch>
               </div>
               <div v-if="form.unlearnAlert == '1'" class="flex align-cen notify-sub">
                  <span>获取课程后</span>
                  <el-input v-model="form.unlearnDays" style="width:120px;margin:0 8px" maxlength="3" oninput="this.value=this.value.replace(/[^0-9]/g,'')" placeholder="7"></el-input>
                  <span>天未学习开始通知</span>
               </div>
            </div>
            <div class="notify-item flex align-cen">
               <span class="notify-label">课程指派通知：</span>
               <el-switch v-model="form.allocateAlert" active-value="1" inactive-value="0"></el-switch>
            </div>
         </div>
            <div class="public-tit flex align-cen" id="addCanvas" v-if="platformAppContentList.length == 0">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  课程详情
            </div>
               <div class="mft public-btn-small">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(-1)"
                     >
                          添加分类  
                    </div>
                </div>
              </div>
              <div class="AppContent">
                  <div class="moreCanvas"
                     v-for="(item,index) in platformAppContentList"
                    :key="index"
                    :id="'addCanvas'+index"
                    >
                     <div class="public-tit flex align-cen" style="margin-bottom:20px">
                        <div class="public-tit-list">
                            <i class="icon-al-database-fill"></i> 分类{{index+1}}
                        </div>
                    </div>
                     <div class="businessList-filter-list flex align-cen">
                            <div class="fl-le flex align-cen">
                    <div class="label">分类标题：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入分类标题【1-5】" v-model="item.title" clearable
                        maxlength="5"
                        > </el-input>
                    </div>
                    </div>
                       <div class="fl-rt flex align-cen">
                    <div class="label">副标题：</div>
                    <div class="el-select1">
                    <el-input placeholder="请输入副标题【1-50】" v-model="item.subhead" clearable maxlength="50"> </el-input>
                    </div>
                    </div>
                       <div class="mft deletBtn"
                    @click="deletCanvas(item)"
                    >
                    删除分类
                    </div>
                    <div class="mft public-btn-small" style="padding-left:0" v-if="index == platformAppContentList.length-1">
                     <div class="public-btn-small-primary"
                     @click="addCanvas(index+1)"
                     >
                          添加分类  
                    </div>
                </div>
                     </div>
                           <div class="quillsFLex flex align-cen">
              <quillsTemplate  @sendStatus="emitFun" :propData="item.content"
                      :currindex="index"
                    :ref="'quillTemplate' + index"
                    :placeName="'电脑端富文本'"
                    ></quillsTemplate>
                     <quillsTemplate  @sendStatus="emitFun1" :propData="item.mobileContent"
                      :currindex="index"
                    :ref="'quillTemplate1' + index"
                     :placeName="'移动端富文本'"
                    ></quillsTemplate>
                </div>
                  </div>
               </div>
            </div>
         </div>
 <!-- 选择试卷弹框 -->
     <el-dialog
  title="选择相关试卷"
  :visible.sync="centerDialogVisible0"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible0"
   @close="reback1"
  >
  <div class="forminfo"> 
    <paperTemplate :selectType='centerDialogVisible0'
    :importName="'course'"
    :isAppId="isShowId"
    @sendStatus="classSelect"
    ref="paperTemplate"
    ></paperTemplate>
       <div class="authbtn flex align-cen">
             <el-button plain @click="reback1">取消</el-button>
              <el-button type="primary" class="mft" @click="onSubmit1">确认选择</el-button>
        </div>
  </div>
     </el-dialog>
                             <!-- 打开学生组 -->
      <el-dialog
  title="选择分组"
  :visible.sync="centerDialogVisible"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible"
  >
    <div class="forminfo">
          <el-alert
            title="当勾选分组后，其分组下学员都可以学习"
            type="warning"
            :closable="false"
             show-icon
            >
        </el-alert>
         <div class="form-check">
        <el-checkbox-group v-model="studentCheck">
            <el-checkbox v-for="(item,index) in studentClass"   :label="item.id" >
               <div class="jstree-node flex align-cen">
                <i class="jstree-icon"></i>
                <span class="jstree-name">{{item.name}}</span>
                </div> 
             </el-checkbox>
            </el-checkbox-group >
        </div>
        <div class="authbtn flex align-cen">
        <el-button plain @click="centerDialogVisible = false"> 取消</el-button>
              <el-button type="primary" @click.stop="putCheck(1)">选择</el-button>
    </div>
    </div>
      </el-dialog>
          <!-- 打开学生列表 -->
      <el-dialog
  title="选择学员"
  :visible.sync="centerDialogVisible1"
  width="60%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible1"
  >
  <div class="forminfo">
        <studentTemplate
          :authType='1'
    ref="studentTemplate"
     @sendStatus="stclassSelect"
        ></studentTemplate>
         <div class="authbtn flex align-cen">
        <el-button plain @click="centerDialogVisible1 = false"> 取消</el-button>
              <el-button type="primary" @click.stop="putCheck(2)">选择</el-button>
    </div>
  </div>
      </el-dialog>
     </div>
</template>
<script>
import {getAllCourseClassify,addCourse,deletCourse,courseAllocateList,getAllStudentClass} from "@/api/enterprise/index"  //课程分类、新增课程、课程详情
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import CropperImage from "@/components/CropperImage.vue";  //裁剪组件
import quillsTemplate from "@/components/quills";  //多富文本组件
import paperTemplate from "@/weteacheManage/enTestPaper/index.vue"; //将试卷列表页面作为组件使用
import  studentTemplate from "@/weteacheManage/member/studentList/index.vue"; //将题目分类页面作为组件使用
export default {
    name:'addCourse',
    components: {
        topicSteps,
        CropperImage,
        quillsTemplate,
        paperTemplate,
        studentTemplate
    },
    data() {
        return {
          centerDialogVisible1:false,
          centerDialogVisible:false,
          checked:false,
          checked1:false,
           dynamicTags1:[],
            dynamicTags2:[],
             studentClass:[],
            studentCheck:[],
          businessInfo:{},
        isShowId:false,
        centerDialogVisible0: false,
        relationList:[],
        selectList:[],
        nowIndex:0,
        platformAppContentList:[],
        platformAppRelationList:[],
        oploadDialogVisible:false,
        uploadBoolean:false,
        headers:{},
        loading:false,
        options:[],
        form:{
            title:'',
            classifyId:'',
            logo:'',
            recommend:'0',
            sort:'',
            introduction:'', 
            payType:'',
            payModel:'',
            allocateList:[],
            skuList:[],
            updateAlert:'0',
            unlearnAlert:'0',
            allocateAlert:'0',
            unlearnDays:7
        },
        rules:{
             title: [{ required: true, message: '请输入您的课程标题', trigger: 'blur' },
             { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
             ],
             classifyId: [{ required: true, message: '请选择课程分类', trigger: 'change' }],
             logo:[{ required: true, message: '请上传课程封面图', trigger: 'blur' }],
               payType:[{ required: true, message: '请选择付费类型', trigger: 'blur' }],
                 payModel:[{ required: true, message: '请选择付费模式', trigger: 'blur' }],
        },
         propList:[
            {
                steps:1,
                text:'基本信息',
            },
            {
                steps:2,
                text:'章节编辑',
            },{
                steps:3,
                text:'完成',
            }

        ]
        }
    },
    created () {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getCourseClass()
        let token = this.$locaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        if(this.$route.query.id) this.getDetail()
         this.studetChFun(1)
         this.studetChFun(2)
    },
    methods: {
         // 标签移除
        handleClose(tag,type){
           this['dynamicTags' + type].splice(this['dynamicTags' + type].indexOf(tag), 1);
            if(type == 1) {
                this.studentCheck = this.studentCheck.filter(item => this.dynamicTags1.some(ele=>ele.id===item))
            }
            //  if(type == 2) this.studentCheck = this.studentCheck.filter(item => this.dynamicTags1.some(ele=>ele.id===item))
            // if(type == 2) this.studentCheck = this.studentCheck.filter(item => this.dynamicTags1.some(ele=>ele.id===item))
        },
       stclassSelect(val,val1){
            this.dynamicTags2 = val
        },
        // 选择学生组
        putCheck(type){
            if(type == 1){
                if(!this.studentCheck.length) return this.$util.Notifi('请先勾选','error','fa-exclamation-circle')
                
                    this.dynamicTags1 = this.studentClass.filter(item => this.studentCheck.some(ele=>ele===item.id))
                this.centerDialogVisible = false
            }
            if(type == 2){
                if(!this.dynamicTags2.length) this.$util.Notifi('请先勾选','error','fa-exclamation-circle')
                this.centerDialogVisible1 = false
            }
        },
        getclass(type){
            this.studentCheck = []
            getAllStudentClass({businessId:this.businessInfo.id,name:''})
            .then(res =>{
                this.studentClass = res.data
                if(this.dynamicTags1.length){
                   for (let key in this.dynamicTags1) {
                    this.studentCheck.push((this.dynamicTags1[key].businessId ? this.dynamicTags1[key].id : this.dynamicTags1[key].allocateId)) 
                   }
                    
                }

            })
        },
          // 打开学生组
        openStu(type){
           if(type == 1){
             this.centerDialogVisible = true
            this.getclass(1)
           }
           if(type == 2){
            this.centerDialogVisible1 = true
            this.$nextTick(function () {   
                 this.$refs.studentTemplate.steditfun(this.dynamicTags2)    
             })
           }
        },
       studetChFun(type){
        courseAllocateList({id:this.$route.query.id,type:type})
        .then(res =>{
            // console.log(res.data)
           this['dynamicTags' + type] = res.data || []
           if(type == 1 && this.dynamicTags1.length) this.checked = true
            if(type == 2 && this.dynamicTags2.length) this.checked1= true

        })
        },
    //   课程详情
    getDetail(){
        deletCourse(
                {id:this.$route.query.id},
                'get')
            .then(res =>{
                 this.form = {
                    title:res.data.title,
                    classifyId:res.data.classifyId,
                    logo:res.data.logo,
                    recommend:res.data.recommend,
                    introduction:res.data.introduction,
                    sort:res.data.sort,
                    payType:res.data.payType,
                    payModel:res.data.payModel,
                    skuList:res.data.skuList ? res.data.skuList : [{ name:'', originalPrice:'', salePrice:'',deadline:'',accountNum:''}],
                    allocateList:[],
                    updateAlert:res.data.updateAlert || '0',
                    unlearnAlert:res.data.unlearnAlert || '0',
                    allocateAlert:res.data.allocateAlert || '0',
                    unlearnDays:res.data.unlearnDays || 7,
                }
                this.isShowId = true
                this.platformAppContentList = res.data.contentList
                this.relationList = res.data.paperList
            })
            .catch(err => {})
    },
          // 添加规格
      addtab(){
        if(this.form.skuList.length > 4){
          return this.$message.error('最多只能添加5个')
        }else{
           this.form.skuList.push({
          name:'',
          originalPrice:'',
          salePrice:'',
          deadline:'',
          accountNum:'',
        })
        }
      },
      // 规格删除
      deltab(data){
           let arr = []
          arr.push(data)
        let delet= this.form.skuList.filter(item=>!arr.some(ele=>ele===item)) 
        if(this.form.skuList.length == 1){
          this.$message.error('需保留一个')
        }else{
          this.form.skuList= delet
        }
         
      },
           // 付费模式改变
      priceChange(){
        if(this.form.payModel == 2){
          this.form.skuList = []
        }
      },
         deletPro(data){
              let arr = []
            arr.push(data)
        let delet= this.relationList.filter(item=>!arr.some(ele=>ele.id===item.id)) 
         this.relationList = delet
        //   this.$refs.appTemplate.editfun(this.relationList) 
        },
         // 应用列表取消选择
        reback1(){
            this.$refs.paperTemplate.remove()  
             if(this.$route.query.id) this.isShowId = true
             this.centerDialogVisible0 = false  
        },
        // 应用列表确认选择
         onSubmit1(){
           // 过滤数组中的对象，去除重复项  
                let uniqueObjects = this.selectList.filter((item, index) => {  
                  // 如果是对象，则进行去重逻辑  
                  if (typeof item === 'object' && item !== null) {  
                    // 使用 findIndex 查找数组中是否存在相同的对象  
                    return this.selectList.findIndex(otherItem => JSON.stringify(item) === JSON.stringify(otherItem)) === index;  
                  }  
                  // 如果不是对象，则直接返回 true，因为非对象元素不会重复  
                  return true;  
                });  
            this.relationList = uniqueObjects
           this.centerDialogVisible0 = false
        },
             classSelect(val,val1){
            this.selectList = val
            this.isShowId = val1
        },
         // 打开试卷列表
          openBl(){
             this.centerDialogVisible0 = true     
                     this.$nextTick(function () {   
                        this.$refs.paperTemplate.editfun(this.relationList)    
                    })
           
        },
               // 子组件触发的方法
        emitFun(val,index){
            this.platformAppContentList[index].content = val
        },
            emitFun1(val,index){
            this.platformAppContentList[index].mobileContent = val
        },

              // 删除分类
        deletCanvas(data){
            let arr = []
            arr.push(data)
        let delet= this.platformAppContentList.filter(item=>!arr.some(ele=>ele ===item)) 
       this.platformAppContentList = delet
        this.nowIndex == 0 ?  this.nowIndex = 0 : this.nowIndex = this.nowIndex -1
        },
                 // 添加分类
        addCanvas(index){
            if(index>=0){
                this.nowIndex=index
            }else{
                this.nowIndex=0
            }
            this.platformAppContentList.push({
                title:'',
                subhead:'',
                content:'',
                mobileContent:''
            })
        },
             // 获取分类
        getCourseClass(){
            this.options = []
             getAllCourseClassify({
                name:'',
                businessId:this.businessInfo.id
             })
            .then(res => {
              if(res.data){
               this.options = res.data
              }else{
                    this.options = []
             }

            })
            .catch(err => {
            })
        },
        // 下一步
         openSteps(formName){
              this.platformAppRelationList = []
            for (const key in this.relationList) {
                this.platformAppRelationList.push(
                     {
                        paperId:!this.isShowId ? this.relationList[key].id : this.relationList[key].paperId
                    }
                )
            }
            if(this.checked || this.checked1){
                if(this.checked){
               if(!this.dynamicTags1.length) return this.$util.Notifi('请选择指定组','error','fa-exclamation-circle')
                }else if(this.checked1){
             if(!this.dynamicTags2.length) return this.$util.Notifi('请选择指定学员','error','fa-exclamation-circle')
            }
              }else{
                return this.$util.Notifi('请选择指定组或指定学员','error','fa-exclamation-circle')
              }
              if(!this.checked){
                this.dynamicTags1 = []
              }
              if(!this.checked1){
                this.dynamicTags2 = []
              }
              let mergedArray = [...this.dynamicTags1.map(item => ({allocateId:(item.businessId || item.id == 1 ? item.id : item.allocateId), type: 1})), ...this.dynamicTags2.map(item => ({allocateId:item.businessId ? item.id : item.allocateId, type: 2}))]; 
              this.form.allocateList = mergedArray
             let params = { ...this.form, unlearnDays: Number(this.form.unlearnDays) || 7 };
            let method = "post"
            let appSkuList = this.form.skuList
            if(!this.$route.query.id) params = {...params,contentList:this.platformAppContentList,paperList:this.platformAppRelationList,businessId:this.businessInfo.id},method = "post";
            if(this.$route.query.id) params = {...params,id:this.$route.query.id,contentList:this.platformAppContentList,paperList:this.platformAppRelationList, businessId:this.businessInfo.id},method = "put";
             this.$refs[formName].validate((valid) => { 
                    if(valid){
                      this.commentBness(params,method)
                }
              })
         },
        //  新增修改公共方法
                  commentBness(params,method){
               this.loading = true
                addCourse(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id)  this.$util.Notifi('新增成功','success','fa-check'); 
                           if(this.$route.query.id) this.$util.Notifi('修改成功','success','fa-check');
                          this.nextId = res.data.id; 
                                setTimeout(() => {
                           this.$router.push({
                            name:'enTwoCourse',
                            query:{
                                twoId:this.$route.query.id || this.nextId
                            }
                           })
                             }, 100);
                           }else{
                             this.loading = false
                            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
              // 图片放大
         oploadImgPre(){
            this.oploadDialogVisible = true
            },
        oploadImgDel(){
            this.form.logo = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
        },
         handleAvatarSuccess(res, file) {
        this.form.logo = res.data.url
        
        if(this.form.pic){
        this.uploadBoolean = true
         }
      },
         
    },
}
</script>
<style lang="scss" scoped>
         .settings-box-check{
            padding-left: 25px;
            padding-top: 10px;
            .tagsinput{
            width: 80% !important;
            min-height: 56px;
            max-height: unset;
            height: 56px;
            padding: 0px 12px 0 12px;
            background-color: #ffffff;
            border-radius: 4px!important;
            border: solid 1px #e6e6e6!important;
            overflow-y: auto;
            line-height: 27px;
            margin: 10px 25px;
            .classItem{
                padding-top: 12px;
                .el-tag{
                    margin-right: 10px;
                }
            }
            }
            .select-stu{
                margin-left: 25px;
                background-color: #36aafd;
                color: white;
                border: 1px solid #36aafd;
                padding: 7px 0px;
                border-radius: 4px!important;
                width: 122px;
                cursor: pointer;
                text-align: center;
            }
         }
        .settings-box{
            margin-bottom: 48px;
            .settings-box-tips{
                margin-bottom: 20px;
                .red-div{
                    width: 4px;
                    height: 15px;
                    background-color: #409eff;
                    margin-right: 5px;
                }
                .red-div-p{
                 font-size: 16px;
                letter-spacing: 0px;
                color: #333333!important;
                height: unset;
                font-weight: 700;
                }
            }
        }
   .notify-settings-wrap{
      margin-bottom: 32px;
.notify-item{
         padding: 10px 25px;
         .notify-label{
            min-width: 120px;
            color: #333;
            font-size: 14px;
         }
         .notify-sub{
            margin-top: 12px;
            padding-left: 120px;
            font-size: 14px;
            color: #333;
         }
      }
   }
   .edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
                      .AppContent{
        margin: 20px 0;
        margin-bottom: 100px;
        position: relative;
        .moreCanvas{
            margin-top: 60px;
        }
        .moreCanvas:first-child{
            margin-top: 0;
        }
           .el-select1{
                width: 80%;
            }
        .fl-le{
            width: 40%;
        }
        .fl-rt {
             width: 40%;
        padding-left: 30px;
      }
      .deletBtn{
        margin-left: 30px;
        height: 32px;
        line-height: 30px;
        font-size: 14px;
        padding: 0 16px;
        border-radius: 2px;
        font-family: inherit;
        border-width: 1px;
        border-style: solid;
        text-align: center;
        vertical-align: middle;
        box-sizing: border-box;
        cursor: pointer;
        transition: all 0.3s;
        background: #f56c6c;
        color: #fff;
      }
      .el-input,.el-cascader{
            width: 100%;
        }
     }
           ::v-deep{
                            .quillsFLex{
      .quillTemplate{
        margin-right: 10px !important;
      }
    }
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 371px;
    height: 130px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
  ::v-deep{
       .is-checked{

    .el-radio__label,.el-checkbox__label{
    position: relative;
    padding-left: 5px;
    color: #333;
    font-weight: 400;
    }
.el-checkbox__label{
    padding-left: 10px;
}
   } 
   .el-checkbox__label{
    span{
        font-size: 14px;
        color: #999;
    }
   }
   .el-checkbox-group{
    .el-checkbox{
        margin-bottom: 20px;
        display: block;
    }
}
     .forminfo{
        .form-check{
            padding: 20px 50px;
        }
        .el-checkbox-group{
            .el-checkbox{
                display: flex !important;
                align-items: center !important; 
            }
        }
        .jstree-icon{
             display: block;
            width: 24px;
            height: 24px;
            
            background: url('../../../assets/images/tree-default.svg') no-repeat 0 0;
        }
        .jstree-name{
            padding-left: 5px;
        }
    }
  }
</style>